import { MediaError } from "@videojs/media";
import { loadScript } from "@videojs/utils/dom";
//#region src/iframe-api.ts
const API_URL = "https://www.youtube.com/iframe_api";
/** Load the iframe API once, reusing it if another host already pulled it in. */
async function loadYouTubeApi() {
	const existing = globalThis.YT;
	if (existing?.Player) return existing;
	await loadScript(API_URL);
	const api = globalThis.YT;
	if (!api) throw new Error("YouTube iframe API failed to load");
	await new Promise((resolve) => api.ready(resolve));
	return api;
}
const youtubeErrorCodeToMediaErrorCode = {
	2: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED,
	5: MediaError.MEDIA_ERR_DECODE,
	100: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED,
	101: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED,
	150: MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
};
//#endregion
export { loadYouTubeApi, youtubeErrorCodeToMediaErrorCode };
